/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import ScoreCardHeader from "../Views/ScoreCardHeader";
import "./ScoreCardResultScreen.css";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import filledStar from "../../../assets/images/score-card/score-card-result-star.svg";
import ScoreCardProgressBar from "../Views/ScoreCardProgressBar";
import useWSMApi from "services/api/useWSMApi";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import { trackScoreCardCompleted } from "utils/analytics";
import { useEffect } from "react";

const ScoreCardResultScreen = () => {
  const { fetchUserScoreCardResult } = useWSMApi();
  const navigate = useNavigate();
  const { state } = useLocation() as {
    state?: { hasScoreCards: boolean };
  };

  const { data: scoreCardResult, isLoading } = useQuery({
    queryKey: ["get-user-score-card-result"],
    queryFn: () => fetchUserScoreCardResult(),
    retry: false,
  });

  const persona = scoreCardResult?.data?.persona;
  const readiness = scoreCardResult?.data?.readiness;

  const score: number = readiness?.percentage ?? 0;
  const readinessLevel: string = readiness?.level ?? "Emerging";
  const readinessDescription: string = readiness?.description ?? "";

  const scoreLabel: string = `${readinessLevel} - ${readinessDescription}`;

  const focusItems: string[] = readiness?.whatToFocusOn ?? [];
  const stepsItems: string[] = persona?.threeStepsPlan ?? [];

  useEffect(() => {
    if (!isLoading && score > 0) {
      trackScoreCardCompleted(score);
    }
  }, [isLoading, score]);

  if (isLoading) {
    return (
      <div className="wms-mobile-container" style={{ background: "#1c1c1e" }} />
    );
  }

  return (
    <div className="wms-mobile-container">
      <div className="score-card-result-screen-container">
        <div className="score-card-result-screen-header-sticky">
          <ScoreCardHeader
            title="CARD"
            subTitle="SCORE"
            orangeFirst={true}
            showBackButton={state?.hasScoreCards ?? false}
          />
        </div>
        <div className="score-card-result-screen-content-container">
          <div className="main-card">
            <span className="header-title">Ur Score is</span>
            <ScoreCardProgressBar progress={score} />
            <span className="card-title">
              {scoreLabel.includes(" - ") ? (
                <>
                  {scoreLabel.split(" - ")[0]} -{" "}
                  <span style={{ color: "#9B5DE5" }}>
                    {scoreLabel.split(" - ")[1]}
                  </span>
                </>
              ) : (
                scoreLabel
              )}
            </span>
            <div className="details-container">
              <div className="header">
                <span>
                  WHAT To <span style={{ color: "white" }}>Focus on</span>
                </span>
              </div>
              {focusItems.map((item, idx) => (
                <div key={idx} className="details">
                  <img src={filledStar} alt="star-image" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="details-container">
              <div className="header">
                <span>
                  UR <span style={{ color: "white" }}>3 Steps plan</span>
                </span>
              </div>
              {stepsItems.map((item, idx) => (
                <div key={idx} className="details">
                  <img src={filledStar} alt="star-image" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <span className="bottom-title">
              Detailed{" "}
              <span style={{ color: "#9B5DE5" }}>Persona & Readiness</span>{" "}
              scorecard is{" "}
              <span style={{ color: "#9B5DE5" }}>sent to your email .</span>{" "}
              Please read through it.
            </span>
          </div>
          <span className="bottom-title">
            Still Unclear then{" "}
            <span style={{ color: "white" }}>Connect with us!</span>
          </span>
          {state?.hasScoreCards ? (
            <div
              className="button-container"
              onClick={() => {
                navigate(ROUTE_PATHS.WSM_SCORE_CARD_INITIAL_SCREEN);
              }}
            >
              <>
                <span>
                  Get Ur <span style={{ color: "#9B5DE5" }}>Score Card</span>
                </span>
                <img src={letsDoItIcon} alt="right-arrow-icon" />
              </>
            </div>
          ) : (
            <div
              className="button-container"
              onClick={() => {
                navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
              }}
            >
              <>
                <span>
                  Explore the{" "}
                  <span style={{ color: "#9B5DE5" }}>Application!</span>
                </span>
                <img src={letsDoItIcon} alt="right-arrow-icon" />
              </>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScoreCardResultScreen;
